export default __webpack_public_path__ + "static/media/axonius.6c30d48c.svg";